export {DjangoBaseUser} from './django-base-user';
export {DjangoSessionAuthenticationService} from './django-session-authentication.service';



// WEBPACK FOOTER //
// ./src/app/shared/authorization/custom/index.ts